<script lang="ts">
  import { type Snippet } from "svelte";
  import { createAside } from "./workflowLib.svelte";

  let {
    name,
    children
  } : {
    name: string,
    children : Snippet
  } = $props()

  const aside = createAside(name)
</script>
{#if aside.active}
  {@render children()}
{/if}
